import { render, staticRenderFns } from "./TheButtonLink.vue?vue&type=template&id=03c16272&scoped=true&"
import script from "./TheButtonLink.vue?vue&type=script&lang=js&"
export * from "./TheButtonLink.vue?vue&type=script&lang=js&"
import style0 from "./TheButtonLink.vue?vue&type=style&index=0&id=03c16272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c16272",
  null
  
)

export default component.exports